<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" @click="goBack()" aria-hidden="true">×</button>
                <h4 class="modal-title">{{ $t('new') }}</h4>
            </div>
            <div class="modal-body">
                <form @submit.prevent="store">
                    <div class="modal_content">
                        <div class="row">
                            <div class="col-sm-12 m_bottom_15" :class="{'has-error': errors['currency_id']}">
                                <label class="show">{{ $t('currency') }}</label>
                                <pml-select v-model="record.currency_id" :options="currencies"></pml-select>
                                <span class="error" v-if="errors['currency_id']">{{ errors['currency_id'][0] }}</span>
                            </div>
                            <div class="col-sm-12 m_bottom_15" :class="{'has-error': errors['language']}">
                                <label class="show">{{ $t('language') }}</label>
                                <pml-select v-model="record.language" :options="languages"></pml-select>
                                <span class="error" v-if="errors['language']">{{ errors['language'][0] }}</span>
                            </div>
                            <div class="col-sm-12 m_bottom_15" :class="{'has-error': errors['due_date_at']}">
                                <label class="show">{{ $t('due_date') }}</label>
                                <pml-date-picker v-model="record.due_date_at"></pml-date-picker>
                                <span class="error" v-if="errors['due_date_at']">{{ errors['due_date_at'][0] }}</span>
                            </div>
                            <div class="col-md-12" :class="{'has-error': errors['annotations']}">
                                <label class="show">{{ $t('description_in_quotation') }}</label>
                                <textarea class="form-control" v-model="record.annotations" rows="4" v-pml-autosize></textarea>
                                <span class="error" v-if="errors['annotations']">{{ errors['annotations'][0] }}</span>
                            </div>
                            <div class="col-md-12" :class="{'has-error': errors['additional_info']}">
                                <label class="show">{{ $t('additional_info') }}</label>
                                <pml-summernote v-model="record.additional_info" :value="record.additional_info" :show-deal-btn="false"></pml-summernote>
                                <span class="error" v-if="errors['additional_info']">{{ errors['additional_info'][0] }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="p-20 p-t-0">
                        <span class="btn btn-white" @click="goBack()">{{ $t('cancel') }}</span>
                        <button type="submit" class="btn btn-default pull-right" v-pml-block="isSaving">{{ $t('save') }}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import RoutedModals from '@/utils/mixins/routed-modals'
    import Notify from '@/utils/helpers/notify'
    import { trans } from '@/utils/helpers/translation'
    import { mapGetters } from 'vuex'
    import { create } from '@/services/quotations'

    export default {
        name: 'AddQuotation',
        mixins: [ RoutedModals ],
        data () {
            return {
                record: {},
                errors: [],
                isSaving: false,
                goBackTo: {
                    name: 'dashboard.index'
                }
            }
        },
        computed: {
            ...mapGetters({
                'currencies': 'getCurrencies',
                'languages': 'getLanguages',
                'deal': 'getDealInfo',
                'quotations': 'getDealQuotations',
                'company': 'getCompany'
            })
        },
        mounted () {
            this.record.additional_info = this.company.additional_info
        },
        methods: {
            store () {
                this.isSaving = true

                create(this.$route.params.id, this.record)
                    .then(response => {
                        Notify.success(trans('_notifications.success'))
                        this.$router.push({ name: 'deals.show.quotations.edit', params: { id: this.$route.params.id, quotation: response.id } })
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/quotations/Add.vue